import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find-index";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import Err from "../../../../routes/error";
import { getAll, getById, getAutomation, create, editCampaign, editTrigger, addTrigger, removeTrigger, toggleActive, addEmail, editEmail, removeEmail, deleteClientFromCampaign, downloadGlobalStatistics, deleteDripCampaign, bulkDeleteClientsFromCampaign } from "../api/drip-campaign-api";
import { SET_ALL_CAMPAIGNS, SET_ALL_CAMPAIGNS_ONE, SET_CURRENT_CAMPAIGN, SET_AUTOMATION, SET_TRIGGER_MAPPER, SET_TRIGGER, REMOVE_TRIGGER, SET_STAGE, REMOVE_STAGE, SET_CURRENT_CAMPAIGN_CLIENTS } from "./drip-campaign-mutations";
import { showToast } from "@Shared/utils/constants";
import { delay } from "@Shared/@Utils/utils";
import { cloneDeep, uniqueId } from "lodash";
export const GET_ALL_CAMPAIGNS = "GET_ALL_CAMPAIGNS";
export const GET_CAMPAIGN = "GET_CAMPAIGN";
export const GET_AUTOMATION = "GET_AUTOMATION";
export const CREATE_CAMPAIGN = "CREATE_CAMPAIGN";
export const SUBMIT_CAMPAIGN_DETAILS = "SUBMIT_CAMPAIGN_DETAILS";
export const SUBMIT_TRIGGERS = "SUBMIT_TRIGGERS";
export const SUBMIT_STAGES = "SUBMIT_STAGES";
export const ADD_TRIGGER = "ADD_TRIGGER";
export const SAVE_TRIGGER = "SAVE_TRIGGER";
export const SAVE_TRIGGER_ARGUMENT = "SAVE_TRIGGER_ARGUMENT";
export const DELETE_TRIGGER = "DELETE_TRIGGER";
export const SAVE_STAGE = "SAVE_STAGE";
export const ADD_STAGE = "ADD_STAGE";
export const DELETE_STAGE = "DELETE_STAGE";
export const SAVE_CURRENT_CAMPAIGN = "SAVE_CURRENT_CAMPAIGN";
export const TOGGLE_CURRENT_CAMPAIGN_ACTIVE = "TOGGLE_CURRENT_CAMPAIGN_ACTIVE";
export const TOGGLE_CAMPAIGN_ACTIVE = "TOGGLE_CAMPAIGN_ACTIVE";
export const DELETE_CLIENT = "DELETE_CLIENT";
export const BULK_DELETE_CLIENTS = "BULK_DELETE_CLIENTS";
export const EXPORT_STATISTICS = "EXPORT_STATISTICS";
export const DELETE_CAMPAIGN = "DELETE_CAMPAIGN";
export const LOAD_CAMPAIGN_CLIENTS = "LOAD_CAMPAIGN_CLIENTS";
export const LOAD_PAGINATED_DRIP_CAMPAIGN_CLIENTS = "LOAD_PAGINATED_DRIP_CAMPAIGN_CLIENTS";
const actions = {
  [GET_ALL_CAMPAIGNS]: async context => {
    try {
      const {
        campaigns
      } = await getAll();
      context.commit(SET_ALL_CAMPAIGNS, campaigns);
    } catch (e) {
      Err.handle(e);
    }
  },
  [GET_CAMPAIGN]: async (context, campaignId) => {
    try {
      const {
        campaign
      } = await getById(campaignId);
      if (campaign != null && campaign.stages[0]) campaign.stages[0].isFirst = true;
      context.commit(SET_CURRENT_CAMPAIGN, campaign);
    } catch (e) {
      Err.handle(e);
    }
  },
  [LOAD_CAMPAIGN_CLIENTS]: async (context, campaignId) => {
    try {
      const {
        campaign
      } = await getById(campaignId);
      const {
        clients
      } = campaign || {};
      context.commit(SET_CURRENT_CAMPAIGN_CLIENTS, clients);
    } catch (e) {
      Err.handle(e);
    }
  },
  [LOAD_PAGINATED_DRIP_CAMPAIGN_CLIENTS]: async (context, {
    campaignId,
    paginationData
  }) => {
    try {
      const {
        campaign
      } = await getById(campaignId, paginationData);
      const {
        clients
      } = campaign || {};
      return clients;
    } catch (e) {
      Err.handle(e);
      return [];
    }
  },
  [GET_AUTOMATION]: async context => {
    try {
      var _context;
      const automation = await getAutomation();
      const mapper = _reduceInstanceProperty(_context = automation.triggers).call(_context, (map, obj) => (map[obj.key] = {
        name: obj.name,
        arguments: cloneDeep(obj["trigger-arguments"]),
        style: cloneDeep(obj.style)
      }, map), {});
      context.commit(SET_AUTOMATION, automation);
      context.commit(SET_TRIGGER_MAPPER, mapper);
    } catch (e) {
      Err.handle(e);
    }
  },
  [ADD_TRIGGER]: async (context, {
    data
  }) => {
    context.commit(SET_TRIGGER, {
      trigger: _objectSpread(_objectSpread({}, data), {}, {
        created: true,
        _localId: uniqueId()
      })
    });
  },
  [SAVE_TRIGGER]: async (context, {
    data,
    _localId
  }) => {
    var _context2;
    const trigger = _objectSpread(_objectSpread(_objectSpread({}, _findInstanceProperty(_context2 = context.state.currentCampaign.triggers).call(_context2, t => t._localId == _localId)), data), {}, {
      edited: true
    });
    context.commit(SET_TRIGGER, {
      trigger,
      _localId
    });
  },
  [SAVE_TRIGGER_ARGUMENT]: async (context, {
    data,
    _localId
  }) => {
    var _context3;
    const targetTrigger = _findInstanceProperty(_context3 = context.state.currentCampaign.triggers).call(_context3, t => t._localId == _localId);
    if (!targetTrigger) return;
    const trigger = _objectSpread(_objectSpread({}, targetTrigger), {}, {
      edited: true,
      metadata: _objectSpread(_objectSpread({}, targetTrigger.metadata), data)
    });
    context.commit(SET_TRIGGER, {
      trigger,
      _localId
    });
  },
  [DELETE_TRIGGER]: async (context, {
    _localId
  }) => {
    var _context4;
    let trigger = _findInstanceProperty(_context4 = context.state.currentCampaign.triggers).call(_context4, t => t._localId == _localId);
    if (!trigger) return;
    if (trigger.triggerId) {
      trigger = _objectSpread(_objectSpread({}, trigger), {}, {
        deleted: true
      });
      context.commit(SET_TRIGGER, {
        trigger,
        _localId
      });
    } else {
      context.commit(REMOVE_TRIGGER, _localId);
    }
  },
  [SAVE_STAGE]: async (context, {
    data,
    index
  }) => {
    const stage = _objectSpread(_objectSpread(_objectSpread({}, context.state.currentCampaign.stages[index]), data), {}, {
      edited: true
    });
    context.commit(SET_STAGE, {
      stage,
      index
    });
  },
  [ADD_STAGE]: async (context, {
    data
  }) => {
    const newIndex = context.state.currentCampaign.stages.length;
    context.commit(SET_STAGE, {
      stage: _objectSpread(_objectSpread({}, data), {}, {
        created: true
      }),
      index: newIndex
    });
  },
  [DELETE_STAGE]: async (context, {
    index
  }) => {
    let stage = context.state.currentCampaign.stages[index];
    if (stage.stageId) {
      stage = _objectSpread(_objectSpread({}, stage), {}, {
        deleted: true
      });
      context.commit(SET_STAGE, {
        stage,
        index
      });
    } else {
      context.commit(REMOVE_STAGE, index);
    }
  },
  [SAVE_CURRENT_CAMPAIGN]: async (context, data) => {
    context.commit(SET_CURRENT_CAMPAIGN, data);
  },
  [TOGGLE_CURRENT_CAMPAIGN_ACTIVE]: async context => {
    const {
      active,
      emailVerified
    } = context.state.currentCampaign;
    const {
      campaignId
    } = context.state.currentCampaign;
    try {
      context.commit(SET_CURRENT_CAMPAIGN, {
        active: !active
      });
      if (!emailVerified) throw "notVerified";
      await toggleActive(campaignId);
    } catch (e) {
      await delay(1);
      context.commit(SET_CURRENT_CAMPAIGN, {
        active: active
      });
      if (e === "notVerified") showToast("error", "emailMustBeVerifiedToActivateDripCampaign");else Err.handle(e);
    }
  },
  [TOGGLE_CAMPAIGN_ACTIVE]: async (context, campaignId) => {
    var _context5;
    const campaignIndex = _findIndexInstanceProperty(_context5 = context.state.campaigns).call(_context5, campaign => campaign.campaignId === campaignId);
    const active = !context.state.campaigns[campaignIndex].active;
    const campaign = _objectSpread(_objectSpread({}, context.state.campaigns[campaignIndex]), {}, {
      active
    });
    try {
      await toggleActive(campaignId);
      context.commit(SET_ALL_CAMPAIGNS_ONE, {
        campaign,
        index: campaignIndex
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [DELETE_CLIENT]: async (context, {
    campaignId,
    clientProfileId
  }) => {
    try {
      await deleteClientFromCampaign(campaignId, clientProfileId);
    } catch (e) {
      Err.handle(e);
    }
  },
  [BULK_DELETE_CLIENTS]: async (context, {
    campaignId,
    clientProfileIds
  }) => {
    try {
      await bulkDeleteClientsFromCampaign(campaignId, clientProfileIds);
    } catch (e) {
      Err.handle(e);
      throw e;
    }
  },
  [EXPORT_STATISTICS]: async (context, campaignId) => {
    try {
      const newWindow = window.open();
      const {
        url
      } = await downloadGlobalStatistics(campaignId);
      if (newWindow) newWindow.location.href = url;
    } catch (e) {
      Err.handle(e);
    }
  },
  [DELETE_CAMPAIGN]: async (context, campaignId) => {
    try {
      await deleteDripCampaign(campaignId);
    } catch (e) {
      Err.handle(e);
    }
  },
  [CREATE_CAMPAIGN]: async (context, name) => {
    try {
      const {
        campaignId
      } = await create(name);
      return campaignId;
    } catch (e) {
      Err.handle(e);
    }
  },
  [SUBMIT_CAMPAIGN_DETAILS]: async context => {
    const {
      campaignId
    } = context.state.currentCampaign;
    const currentCampaign = {
      name: context.state.currentCampaign.name,
      fromName: context.state.currentCampaign.fromName,
      emailId: context.state.currentCampaign.emailId,
      description: "",
      address: context.state.currentCampaign.address
    };
    try {
      await editCampaign(campaignId, currentCampaign);
    } catch (e) {
      Err.handle(e);
    }
  },
  [SUBMIT_TRIGGERS]: async context => {
    const {
      triggers,
      campaignId
    } = context.state.currentCampaign;
    try {
      await _Promise.all(_mapInstanceProperty(triggers).call(triggers, async trigger => {
        const data = {
          triggerType: trigger.type,
          triggerMetadata: _objectSpread({}, trigger.metadata),
          exit: trigger.exit
        };
        if (trigger.created) return addTrigger(campaignId, data);
        if (trigger.deleted) return removeTrigger(campaignId, trigger.triggerId);
        if (trigger.edited) return editTrigger(campaignId, trigger.triggerId, data);
      }));
    } catch (e) {
      Err.handle(e);
    }
  },
  [SUBMIT_STAGES]: async context => {
    const {
      stages,
      campaignId
    } = context.state.currentCampaign;
    try {
      for (const stage of stages) {
        const data = {
          templateId: stage.templateId,
          subject: stage.subject,
          previewText: stage.previewText,
          daysToWait: stage.daysToWait,
          timeToSendAt: stage.timeToSendAt,
          ccCoApplicants: stage.ccCoApplicants,
          sendAsSeparate: stage.sendAsSeparate
        };
        if (stage.deleted) {
          await removeEmail(campaignId, stage.stageId);
          continue;
        }
        if (stage.created) {
          await addEmail(campaignId, data);
          continue;
        }
        if (stage.edited) {
          await editEmail(campaignId, stage.stageId, data);
          continue;
        }
      }
    } catch (e) {
      Err.handle(e);
    }
  }
};
export default actions;